/* eslint-disable */
import React, { Component } from 'react';
import Loader from 'react-loader';

export default class Chat extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newMessage: true,
      messageText: '',
      messageId: 0,
      parentId: 0,
    };
    this.openCloseMessageBox = this.openCloseMessageBox.bind(this);
    this.clearMessage = this.clearMessage.bind(this);
    this.checkNewMessage = this.checkNewMessage.bind(this);

    this.Parent = this.Parent.bind(this);
    this.TreeChild = this.TreeChild.bind(this);
    this.Children = this.Children.bind(this);
    this.StructureTree = this.StructureTree.bind(this);
    this.props.lk();
  }

  componentWillMount() {
    const { chatId, toId } = this.props.match.params;
    this.props.loadChatInfo(chatId, toId);
    this.props.loadMessages(chatId);
    this.checkNewMessage();
    window.scrollTo(0, 0);
  }

  openCloseMessageBox(val) {
    this.setState({ newMessage: val });
    this.clearMessage();
  }

  clearMessage() {
    this.setState({ messageText: '', messageId: 0, parentId: 0 });
  }

  checkNewMessage() {
    const { chatId } = this.props.match.params;
    this.countdown = setInterval(() => this.props.loadMessages(chatId), 5000);
  }

  componentWillUnmount() {
    clearInterval(this.countdown);
  }

  Parent(elem, i, prevWidth) {
    const parentWidth =
      elem.parent === 0 ? 100 : `${i + 1 <= 15 ? prevWidth - 2 : 70}`;
    return (
      <div key={i}>
        <div
          className={
            i === 0 && elem.parent !== 0
              ? 'Ch-One-message'
              : 'Ch-One-message-list'
          }
          style={{ width: `${parentWidth}%` }}
        >
          <p className="Ch-One-message__time">
            {elem.created}
            <span className="Ch-One-message__answer underline">
              <a
                onClick={() => {
                  this.setState({ messageId: elem.id, parentId: elem.parent });
                  window.scrollTo(0, document.body.scrollHeight);
                }}
              >
                Ответить
              </a>
            </span>
          </p>
          <p className="Ch-One-message__to">
            От: {elem.fromname}
            {this.props.mid === elem.from && (
              <span className="Ch-One-message__delete underline">
                <a
                  onClick={() =>
                    this.props.deleteMessage(
                      this.props.match.params.chatId,
                      elem.id
                    )
                  }
                >
                  Удалить
                </a>
              </span>
            )}
          </p>
          <p 
            className="Ch-One-message__text"
            style={{wordBreak: 'break-word'}}
          >{elem.message}</p>
        </div>
        <div>
          {elem.arr.map((structure, key) =>
            this.TreeChild(structure, key, parentWidth)
          )}
        </div>
      </div>
    );
  }

  Children(elem, i, minusWidth) {
    return (
      <div
        className={
          i === 0 && elem.parent !== 0
            ? 'Ch-One-message'
            : 'Ch-One-message-list'
        }
        style={{ width: elem.parent === 0 ? '100%' : `${minusWidth - 2}%` }}
      >
        <p className="Ch-One-message__time">
          {elem.created}
          <span className="Ch-One-message__answer underline">
            <a
              onClick={() => {
                this.setState({ messageId: elem.id, parentId: elem.parent });
                window.scrollTo(0, document.body.scrollHeight);
              }}
            >
              Ответить
            </a>
          </span>
        </p>
        <p className="Ch-One-message__to">
          От: {elem.fromname}
          {this.props.mid === elem.from && (
            <span className="Ch-One-message__delete underline">
              <a
                onClick={() =>
                  this.props.deleteMessage(
                    this.props.match.params.chatId,
                    elem.id
                  )
                }
              >
                Удалить
              </a>
            </span>
          )}
        </p>
        <p 
          className="Ch-One-message__text"
          style={{wordBreak: 'break-word'}}
        >
            {elem.message}</p>
      </div>
    );
  }

  TreeChild(c, i, parentWidth) {
    return (
      <div key={i}>
        {c.arr.length > 0
          ? this.Parent(c, i, parentWidth)
          : this.Children(c, i, parentWidth)}
      </div>
    );
  }

  StructureTree() {
    const { treeMessages } = this.props;
    return <div>{treeMessages && treeMessages.map(this.TreeChild)}</div>;
  }

  render() {
    const {
      chat,
      history,
      isLoading,
      match,
      mid,
      deleteChat,
      user,
      photos,
    } = this.props;
    const { newMessage, messageText, messageId, parentId } = this.state;
    const loggedUserName = `${user.lastname} ${user.firstname} ${
      user.patronymic
    }`;
    return (
      <div>
        <div className="22.jpg">
          <div className="captions">
            Взаимодействие между участниками образовательного процесса
          </div>
          <div className="cooperation-prosses justify-content">
            {chat && (
              <div className="Ch-Chat">
                <Loader loaded={!isLoading} color="#7b2b2a">
                  <p className="Ch-Chat__addressee">
                    <span>Адресат:</span>
                    {loggedUserName === chat.fromname
                      ? chat.toname
                      : chat.fromname}
                  </p>
                  <img
                    alt=""
                    className="foto-1 Ch-Chat__foto-Addressee"
                    src={photos[chat.photoid]}
                  />
                  <div className="Ch-Full-chat">{this.StructureTree()}</div>
                  {newMessage && (
                    <div className="cooperation-prosses-right Ch-NewMessage">
                      <p className="Ch-NewMessage__title">
                        Ответ на сообщение  <span className='messageCrop'>{this.props.treeMessages.find(mes => mes.id === this.state.messageId)?.message}</span> :</p>
                      <textarea
                        className="Ch-NewMessage__textarea"
                        value={messageText}
                        onChange={val =>
                          this.setState({ messageText: val.target.value })
                        }
                        cols={20}
                        rows={10}
                        placeholder="Ваше сообщение"
                      />
                      <div className="cooperation-prosses-right-button">
                        <button onClick={() => this.openCloseMessageBox(false)}>
                          Отмена
                        </button>
                        <button
                          onClick={() =>
                            messageText !== ''
                              ? this.props.sendMessage(
                                  messageText,
                                  match.params.chatId,
                                  parentId,
                                  messageId
                                ) && this.clearMessage()
                              : undefined
                          }
                        >
                          Отправить
                        </button>
                      </div>
                    </div>
                  )}
                  <div className="Ch-footer">
                    <a href="/lk">Вернуться в Личный кабинет</a>
                    <a onClick={() => history.push('/messages')}>
                      Вернуться к списку сообщений
                    </a>
                    <a onClick={() => this.openCloseMessageBox(true)}>
                      Написать сообщение
                    </a>
                    {chat.from === mid && (
                      <a
                        onClick={() => {
                          deleteChat(match.params.chatId);
                          history.push('/messages');
                        }}
                      >
                        Удалить чат
                      </a>
                    )}
                  </div>
                </Loader>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
